// @ts-ignore
import { v4 } from "uuid"; // TODO install types
import { UUID } from "../../domain/UUID";

export default function randomUUID<T>(): UUID<T> {
  return v4();
};
